<template>
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0326 11.9243H0.957031V9.07544H10.0326L12.8814 9.07554L21.957 9.07544V11.9243H12.8814H10.0326Z"
            fill="currentColor" />
    </svg>
</template>